<p [ngClass]="{ bold: bold }">{{ text }}</p>
